<template>
  <div :class="$style.templateRow">
    <div :class="$style.selectWrapper">
      <Select
        :class="$style.select"
        isDisabled
        name="operator"
        :options="[]"
        placeholder="Select Operator"
      />
    </div>
    <div :class="$style.selectWrapper">
      <Select
        :class="$style.select"
        isDisabled
        name="value"
        :options="[]"
        placeholder="Select Value"
      />
    </div>
  </div>
</template>

<script>
import { Select } from '@jumpcloud/ui-components';

export default {
  name: 'ConditionRowTemplate',

  components: {
    Select,
  },
};
</script>

<style module>
.templateRow {
  display: grid;
  gap: 1em;
  grid-template-columns: 1fr 1fr;
}

.selectWrapper {
  --input-wrapper-width: auto;
  --input-wrapper-min-width: 10ch;
}
</style>
